
import React, { createContext, useContext, useState } from 'react';

interface SearchContextType {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

const SearchContext = createContext<SearchContextType | undefined>(undefined);

export const SearchProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <SearchContext.Provider value={{ searchQuery, setSearchQuery }}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSearchContext = (): SearchContextType => {
  const context = useContext(SearchContext);
  if (context === undefined) {
    console.warn('useSearchContext must be used within a SearchProvider');
    // Return a default implementation that works without the provider
    // This helps prevent crashes when the provider is not available
    return {
      searchQuery: '',
      setSearchQuery: () => {},
    };
  }
  return context;
};

// Update the existing useSearchState to use the context instead
// This maintains backwards compatibility with existing code
export const useSearchState = useSearchContext;
